export { default } from './OptionsDropdown';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/OptionsDropdown/index.js